export default [
  { label: "Serial No.", name: "serialNumber", type: "text", required: true },
  {
    label: "Device Name",
    name: "deviceName",
    type: "select",
    options: [
      "EEG19-01",
      "BBOX-03",
      "Computer Record",
      "Computer Monitor",
    ],
    required: true,
  },
  {
    label: "Sleep Study Set",
    name: "set",
    type: "select",
    options: [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ],
    required: true,
  },

  {
    label: "Base Location",
    name: "base",
    type: "select",
    options: ["BDT", "LPH", "CHG", "BMH", "RHG"],
    required: true,
  },
  {
    label: "Current Location",
    name: "location",
    type: "select",
    options: ["BDT", "LPH", "CHG", "BMH", "RHG"],
    required: true,
  },
  {
    label: "Model",
    name: "model",
    type: "text",
  },
  { label: "Description", name: "description", type: "text" },
  { label: "Lot No.", name: "lotNumber", type: "text" },
  {
    label: "Qty",
    name: "qty",
    type: "number",
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    options: ["พร้อมใช้งาน", "ส่งซ่อม", "ยกเลิกใช้งาน"],
  },

  { label: "Incoming Date", name: "incomingDate", type: "date" },
  { label: "Note", name: "note", type: "textarea" },
];
